<template>
    <div>
    <QS-common-table
      :data="tableData"
      :columns="writeoffTableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
    />
    </div>
</template>

<script>
import config from '../config'

export default {
  name: 'OrderDetail',
  props: {
    paginationData: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { writeoffTableColumns } = config.call(this)
    return {
      writeoffTableColumns,
    }
  },
  methods: {
    paginationChange(payload) {
      this.$emit('paginationChange', payload)
    },
  },
}
</script>

<style lang="scss"></style>
